<div class="ap-card" (click)="selectCard(value())" data-testid="wrapper">
    @if (imageSource()) {
        <div class="ap-card__image-container">
            <img class="ap-card__image" [src]="imageSource()" [alt]="alt()" data-testid="image" />
        </div>
    }
    <div class="ap-card__body" data-testid="body">
        <span [attr.id]="uniqueId">
            <ng-content></ng-content>
        </span>
        <ap-radio-button
            class="ap-card__radio-button"
            [name]="name()"
            [label]="selectionLabel()"
            [value]="value()"
            [ariaDescribedby]="uniqueId"
            [formControl]="control()"
            data-testid="radio-button"
        >
        </ap-radio-button>
    </div>
</div>
